import React, { Component } from 'react'
import OrderPicker from './OrderPicker'
import './SearchResultEdit.css'

class SearchResultEdit extends Component {
  constructor() {
    super()
    this.state = {
      hidden: true
    }
    this.toggleEditPanel = this.toggleEditPanel.bind(this)
  }
  handleChange(e, s, r) {
    const result = this.props.searches[s].results[r]
    const updatedResult = {
      ...result,
      [e.target.name]: e.target.value
    }
    this.props.updateSearchResult(this.props.searchId, r, updatedResult)
  }
  toggleEditPanel() {
    this.setState({
      hidden: !this.state.hidden
    })
  }
  render() {
    const results = this.props.searches[this.props.searchIndex].results
    let maxiHeight = '1000px'
    let clickText = 'Close'
    let borderColor = '#777'
    if (this.state.hidden) {
      maxiHeight = '0'
      clickText = 'Expand'
      borderColor = '#fff'
    }
    let transitionString = 'all .25s ease-in-out'
    let toggleStyle= {maxHeight: maxiHeight, overflow: 'hidden', borderColor: borderColor, transition: transitionString}
    return(
      <div className="result-edit">
      <div className="result-edit-header">
        <div className="result-edit-header-left">
          <OrderPicker 
            resultIndex={this.props.resultIndex} 
            resultId={this.props.result.id} 
            searchIndex={this.props.searchIndex} 
            results={results}
            updateResultOrder={this.props.updateResultOrder} /> 
            <div className="result-edit-header-title">{this.props.result.title}</div>
        </div>
        <div className="result-edit-header-right">
          <button className="btn" onClick={this.toggleEditPanel}>{clickText}</button>
          <button className="btn btn-delete" onClick={() => this.props.deleteSearchResult(this.props.searchId, this.props.resultIndex)}>Delete</button>
        </div>
      </div>
      <div className='result-edit-body' style={toggleStyle}>
        <div className="result-edit-wrapper" >
          <div className="search-result preview">
            <h3>{this.props.result.title}</h3>
            <p className="search-result-url">{this.props.result.link}</p>
            <p>{this.props.result.descr}</p>
          </div>
        <p className="result-edit-instructions">Edit your search result in the fields below. You'll see your changes applied instantly in the live update view above.</p>
          <input type="text" name="title" value={this.props.result.title} placeholder="Search result title"
              onChange={(e) => this.handleChange(e, this.props.searchIndex, this.props.resultIndex)} />
          <input type="text" name="link" value={this.props.result.link} placeholder="Search result link"
              onChange={(e) => this.handleChange(e, this.props.searchIndex, this.props.resultIndex)} />
          <textarea name="descr" rows="4" maxLength="300" value={this.props.result.descr} type="text" placeholder="Search Result description"
              onChange={(e) => this.handleChange(e, this.props.searchIndex, this.props.resultIndex)} ></textarea>
          
        </div>
      </div>
    </div>
    )
  }
}

export default SearchResultEdit


// WEBPACK FOOTER //
// ./src/components/SearchResultEdit.js